// a custom-crafted Leaflet control for that legend
// styling is in the map's .css file
L.Control.Legend = L.Control.extend({
	options: {
		position: 'bottomright'
	},
	initialize: function(options) {
		L.setOptions(this,options);
	},
	onAdd: function (map) {
		this._map = map;
		var myself = this;

		// create the basic button
		this.button = L.DomUtil.create('div', 'leaflet-control leaflet-bar leaflet-legend-control');
		this.button.innerHTML = 'Legend';

		// create the second control which this controls toggles
		setTimeout(function () {
			myself.legendcontent = new L.Control.LegendContent(myself.options).addTo(myself._map);

			if ( $(window).width() >= 768) { // again, many changes in short time, sorry for the mess
				myself.expand();  // starting state: wide enough = expand
			}
		}, 1000);

		// the usual event-propagation stuff so double-clicking the legend doesn't double-click the map
		L.DomEvent.disableClickPropagation(this.button);
		L.DomEvent.disableScrollPropagation(this.button);

		// click to toggle... and stop propagation to the map
		// most other controls such as collapsing, are hacked in via jQuery due to time constraints
		L.DomEvent.addListener(this.button, 'click', function () {
			myself.toggle();
		});

		// all done
		return this.button;
	},
	toggle: function (html) {
		this.legendcontent.toggle();
	},
	expand: function (html) {
		this.legendcontent.expand();
	},
	collapse: function (html) {
		this.legendcontent.collapse();
	}
});

L.Control.LegendContent = L.Control.extend({
	options: {
		position: 'bottomright'
	},
	initialize: function(options) {
		L.setOptions(this,options);
	},
	expand: function (html) {
		L.DomUtil.addClass(this.content, 'leaflet-legend-visible');
	},
	collapse: function (html) {
		L.DomUtil.removeClass(this.content, 'leaflet-legend-visible');
	},
	toggle: function () {
		var already = L.DomUtil.hasClass(this.content, 'leaflet-legend-visible');
		if (already) {
			this.collapse();
		}
		else {
			this.expand();
		}
	},
	onAdd: function (map) {
		this._map = map;
		var myself = this;
		this.content = L.DomUtil.create('div', 'leaflet-control leaflet-bar leaflet-legend-content');

		// this whole shebang is VERY hardcoded towards this one use case, and underwent several iterations on a small budget; please excuse the mess
		// checkbox onChange handlers simply call window.toggleLayerByName() to toggle the layer named same as the checkbox
		// see also the GeoJSON loaders and CSV loaders which load these layers
		// see also MARKER_ZINDEX_STACKING which defines the stacking order of the POI marker layers (TL;DR = top of legend should be top of stack, occluding those lower in the legend)
		// see also MARKER_ICONS which defines corresponding icons for these marker-layers
		var html = '';
		html += '<label><input type="checkbox" value="maintrail" checked onChange="toggleLayerByName(this.value, this.checked)" /> Catamount Trail</label>';
		html += '<div class="section">';
		html += '    <img class="swatch" src="images/legend_ungroomed.png" /> Ungroomed<br/>';
		html += '    <img class="swatch" src="images/legend_groomed.png" /> Groomed Nordic<br/>';
		html += '    <img class="swatch" src="images/legend_snowmobile.png" /> Snowmobile Trail<br/>';
		html += '    <img class="swatch" src="images/legend_unplowed.png" /> Unplowed Road<br/>';
		html += '    <img class="swatch" src="images/legend_road.png" /> Road Walk<br/>';
		html += '</div>';
		html += '<label><input type="checkbox" value="sidetrail" onChange="toggleLayerByName(this.value, this.checked)" /> Connector Trails</label>';
		html += '<div class="section">';
		html += '    <img class="swatch" src="images/legend_ungroomed_dash.png" /> Ungroomed<br/>';
		html += '    <img class="swatch" src="images/legend_groomed_dash.png" /> Groomed Nordic<br/>';
		html += '    <img class="swatch" src="images/legend_snowmobile_dash.png" /> Snowmobile Trail<br/>';
		html += '    <img class="swatch" src="images/legend_unplowed_dash.png" /> Unplowed Road<br/>';
		html += '</div>';
		html += '<label><input type="checkbox" value="trailsections" checked onChange="toggleLayerByName(this.value, this.checked)" /> Sections</label>';
		html += '<div class="section">';
		html += '    <img class="swatch" src="images/legend_section.png" /> Section Boundary<br/>';
		html += '</div>';
		html += '<br/>';
		html += '<label><input type="checkbox" value="parking1" onChange="toggleLayerByName(this.value, this.checked)" /> <img src="images/icon_access.png" class="marker" /> Primary Trailhead Parking</label>';
		html += '<label><input type="checkbox" value="parking2" onChange="toggleLayerByName(this.value, this.checked)" /> <img src="images/icon_access_other.png" class="marker" /> Other Trailhead Access</label>';
		html += '<label><input type="checkbox" value="sponsor" onChange="toggleLayerByName(this.value, this.checked)" /> <img src="images/icon_sponsor.png" class="marker" /> CTA Business Sponsor</label>';
		html += '<label><input type="checkbox" value="food" onChange="toggleLayerByName(this.value, this.checked)" /> <img src="images/icon_meals.png" class="marker" /> Restaurant/Pub</label>';
		html += '<label><input type="checkbox" value="lodging" onChange="toggleLayerByName(this.value, this.checked)" /> <img src="images/icon_lodging.png" class="marker" /> Lodging</label>';
		html += '<label><input type="checkbox" value="backcountry" onChange="toggleLayerByName(this.value, this.checked)" /> <img src="images/icon_backcountry.png" class="marker" /> Backcountry Zone</label>';
		html += '<label><input type="checkbox" value="nordicski" onChange="toggleLayerByName(this.value, this.checked)" /> <img src="images/icon_nordic.png" class="marker" /> Nordic Ski Area</label>';
		html += '<label><input type="checkbox" value="alpineski" onChange="toggleLayerByName(this.value, this.checked)" /> <img src="images/icon_alpine.png" class="marker" /> Alpine Ski Area</label>';
		this.content.innerHTML = html;

		// the usual event-propagation stuff so double-clicking the legend doesn't double-click the map
		L.DomEvent.disableClickPropagation(this.content);
		L.DomEvent.disableScrollPropagation(this.content);

		// all done
		return this.content;
	}
});



// WEBPACK FOOTER //
// ./js/leaflet-control-legend.js